import { createStore } from 'vuex'
import axios from 'axios';
import { StreamChat } from "stream-chat";


export default createStore({
  state: {
    isLogin: false,
    // DEVELOPMENT
    // baseUrl: "https://backdev.amaqaria.com/",
    // backend: "https://backdev.amaqaria.com",
    // mediaUrl: "https://backdev.amaqaria.com/uploads/",
    // LOCAL
    // baseUrl: "http://localhost:8081/",
    // backend: "http://localhost:8081",
    // mediaUrl: "http://localhost:8081/uploads/",
    // LIVE 
    baseUrl: "https://backend.aqaralmuhaysini.com/",
    backend: "https://backend.aqaralmuhaysini.com",
    mediaUrl: "https://backend.aqaralmuhaysini.com/uploads/",
    isLoading: true,
    userName: "",
    email: "",
    isSuperUser: false,
    permissions: [],
    googleMapApi: 'AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg',
    avatar: null,
    streamToken: null,
    streamId: null,
    chatClient: null,
  },
  getters: {
    GET_USER(state) {
      return state.isLogin;
    },
    BASE_URL(state) {
      return state.baseUrl;
    },
    LOADING(state) {
      return state.isLoading;
    },
    GET_USER_DATA(state) {
      return {
        userName: state.userName,
        email: state.email,
        isSuperUser: state.isSuperUser,
        permissions: state.permissions,
        avatar: state.avatar,
        streamToken: state.streamToken,
        streamId: state.streamId,
      }
    },
    MEDIA_URL(state){
      return state.mediaUrl;
    },
    BACKEND_URL(state){
      return state.backend;
    },
    GOOGLE_MAP_API(state){
      return state.googleMapApi;
    },
    CHAT_CLIENT(state){
      return state.chatClient;
    }
  },
  mutations: {
    SET_USER_DATA(state, admin){
      state.isLogin = true;
      if(admin.token) {
        localStorage.setItem('userToken', admin.token);
      }
      state.userName = admin.name;
      // state.email = admin.email;
      state.isSuperUser = admin.isSuperUser;
      state.permissions = admin.permissions;
      state.avatar = admin.avatar ?? null;
      state.streamToken = admin.streamToken ?? null;
      state.streamId = admin.streamId ?? null;
      
      if(admin.streamToken){
        state.chatClient = StreamChat.getInstance("9u5sfhq2nx3t", {
          timeout: 6000,
        });
  
        const userObj = {
          id: admin.streamId,
          name: admin.name,
          image: (admin.avatar)? `${state.mediaUrl}${admin.avatar}` : null,
        };
        const userToken = admin.streamToken;
        
        state.chatClient.connectUser(userObj, userToken).then(() => {
          state.isLoading = false;
        }).catch(err => {
          state.chatClient = null;
          state.isLoading = false;
        });
      }else{
        state.isLoading = false;
      }
    },
    REMOVE_USER_DATA(state) {
      state.isLogin = false;
      localStorage.removeItem('userToken');
      if(state.chatClient)
        state.chatClient.disconnectUser().then(() => {
          state.chatClient = null;
        });
      state.isLoading = false;
    }
  },
  actions: {
    async checkUser(context) {
      if(localStorage.getItem('userToken')) {
        // axios.defaults.headers.common['X-Admin-Token'] = localStorage.getItem('userToken');
        axios.get('/api/admin/admins/currentAdmin').then( res => {
          // console.log(res);
          context.commit('SET_USER_DATA', res.data.admin);
        }).catch(err => {
          context.commit("REMOVE_USER_DATA");
        })
      }else {
        context.commit("REMOVE_USER_DATA");
      }
    }

  },
  modules: {
  }
})